import React from "react";

import { AiPart, PickType } from "@intelligems/ig-types";
import { Message, MessageContent } from "@src/components/ai-elements/message";
import { cn } from "@src/lib/utils";
import { useExecutionPanelSlotProps } from "@src/features/ai/components/WorkflowEditor/execution/panel/ExecutionPanelContext";
import { Text } from "./Text";
import { WithDebugMessages } from "./WithDebugMessages";
import {
  FlattenedPart,
  MessageFlags,
} from "@src/features/ai/components/WorkflowEditor/execution/types";
import { isRenderableTextPart } from "@src/features/ai/components/WorkflowEditor/execution/turn/part-processor";

type AssistantTestMessageProps = {
  item: FlattenedPart;
  part: PickType<AiPart, "text">;
  debug?: boolean;
  isLast?: boolean;
} & Pick<MessageFlags, "disableResponseWordByWordLoading" | "layoutDensity">;

export const AssistantText = ({
  item,
  part,
  debug,
  isLast,
  disableResponseWordByWordLoading,
  layoutDensity,
}: AssistantTestMessageProps) => {
  const getSlotProps = useExecutionPanelSlotProps();
  const bubble = getSlotProps("assistantMessage");

  if (!isRenderableTextPart(part)) return null;

  return (
    <WithDebugMessages item={item} part={part} debug={debug}>
      <Message
        className={layoutDensity === "compact" ? "gap-1.5 py-2" : undefined}
        from={"assistant"}
      >
        <MessageContent
          className={cn(
            layoutDensity === "compact" && "max-w-[92%] gap-1 px-3 py-2",
            bubble?.className,
            isLast && bubble?.lastClassName
          )}
        >
          <Text
            text={part.text}
            state={part.state}
            isLast={isLast}
            disableResponseWordByWordLoading={disableResponseWordByWordLoading}
          />
        </MessageContent>
      </Message>
    </WithDebugMessages>
  );
};
